module.exports = __webpack_public_path__ + "static/media/JR BIPC(20-06-2026).981fef8e.xlsx";